import { FC } from 'react';
import DocumentLinkIcon from '../icons/DocumentLinkIcon';
import { ILinks } from '../types';

interface IProps {
  links: ILinks;
}

const Links: FC<IProps> = ({ links }) => {
  const linksNodes = Object.entries(links).reduce((accumulator, item) => {
    const [linkTitle, linkObj] = item;

    const link = linkObj?._text;

    if (linkTitle && link) {
      accumulator.push(
        <a
          href={link}
          style={{ marginRight: 10 }}
          key={linkTitle}
          title={linkTitle}
        >
          <DocumentLinkIcon documentType={linkTitle} />
        </a>,
      );
    }
    return accumulator;
  }, []);

  return <>{linksNodes}</>;
};

export default Links;
